import type { AllRouteEndpoints } from "../routeTypes";
export const engagementContentBlocksDuplicateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/content_blocks",
  "/engagement/:app_group_id/feature_limitations",
];
